var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGraduationHatIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M26 22.5106V18.0022C26 17.733 26 17.5984 25.959 17.4796C25.9228 17.3745 25.8636 17.2788 25.7858 17.1993C25.6979 17.1095 25.5775 17.0493 25.3367 16.9289L18.5 13.5106M6.5 15.0106V25.2205C6.5 25.7784 6.5 26.0573 6.58703 26.3015C6.66396 26.5174 6.78935 26.7129 6.95357 26.8727C7.13932 27.0536 7.39291 27.1698 7.90003 27.4023L17.5 31.8023C17.8679 31.9709 18.0518 32.0552 18.2434 32.0884C18.4132 32.1179 18.5868 32.1179 18.7566 32.0884C18.9482 32.0552 19.1321 31.9709 19.5 31.8023L29.1 27.4023C29.6071 27.1698 29.8607 27.0536 30.0464 26.8727C30.2106 26.7129 30.336 26.5174 30.413 26.3015C30.5 26.0573 30.5 25.7784 30.5 25.2205V15.0106M3.5 13.5106L17.9633 6.27892C18.1601 6.18054 18.2585 6.13134 18.3617 6.11198C18.4531 6.09483 18.5469 6.09483 18.6383 6.11198C18.7415 6.13134 18.8399 6.18054 19.0367 6.27892L33.5 13.5106L19.0367 20.7423C18.8399 20.8407 18.7415 20.8898 18.6383 20.9092C18.5469 20.9264 18.4531 20.9264 18.3617 20.9092C18.2585 20.8898 18.1601 20.8407 17.9633 20.7423L3.5 13.5106Z",
    stroke: "#C99BF6",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraduationHatIcon);
export default __webpack_public_path__ + "static/media/graduationHatIcon.c6a4869e34ee475310ef5c9aa66ae179.svg";
export { ForwardRef as ReactComponent };